export default {
  active: 'Override de ngtorch activo: {ref} ({sha})',
  activeBranch: 'Override de ngtorch activo: último commit de {ref}',
  reinstalling: '· reinstalando metadatos del paquete',
  manage: 'Administrar',
  disable: 'Desactivar'
}
